<style scoped>
    .login-background{background: url(/img/login/login-background.png) no-repeat;background-size: 100% 100%;position: fixed;width: 100%;max-width: 100%;height: 100%;z-index: 999;top: 0;font-size: 0;}
    .login-background2{background: url(/img/login/login-background2.png) no-repeat;background-size: 100% 100%;width: 35%;height: 100%;text-align: center;position: relative;display: inline-block;max-width: 640px;}
    .ylPlatform{font-size: 32px;color: #ffffff;margin-top: 35px;}
    .loginFrame{width: 460px;height: 450px;background-color: rgba(255,255,255,0.9);position: absolute;display: inline-block;left: 50%;transform: translate(-50%,-50%);top: 50%;text-align: center;}
    .inputTips{color:#707070;font-size: 14px;text-align: left;margin-left: 45px;margin-top: 25px;margin-bottom: 10px;}
    .loginFrame >>> .ivu-input{width: 380px;height: 46px;border-radius: 22px;font-size: 14px;color: #c7cdd4;padding-left: 45px;}
    .loginFrame >>> .ivu-input-prefix, .ivu-input-suffix{top: 6px;left: 10px;}
    .loginFrame >>> .ivu-input-prefix i, .ivu-input-suffix i{font-size: 22px;}
    .register{color: #00a2e9;text-decoration:underline;display: inline-block;}
    .forgetPassword{font-size: 14px;color: #00a2e9;float: right;margin-right: 45px;text-decoration:underline;}
</style>

<template>
    <div class="login-background">
        <div class="login-background2">
           <div style="position: absolute;left: 50%;transform: translate(-50%,-50%);top: 50%;width: 100%">
               <img :src="companyName == '刚峰'?'/img/header/GFlogo.png':'/img/login/logo.png'">
               <p class="ylPlatform">{{$store.state.userInfo.companyShortName||companyName+'互联网律所管理平台'}}</p>
           </div>
            <p style="color;#c7cdd4;font-size: 14px;position: absolute;bottom: 40px;text-align: center;width: 100%">技术支持：律蛙智能</p>
        </div>
        <div style="width: 65%;height: 100%;position: relative;display: inline-block">
            <div class="loginFrame">
                <p style="color:#c7cdd4;font-size: 26px;margin-top: 30px;">登录</p>
                <div>
                    <p class="inputTips">手机号码 / username</p>
                    <Input prefix="ios-contact-outline" v-model="phoneNumber" placeholder="请输入您注册的手机号码" style="width: auto" />
                </div>
                <div>
                    <p class="inputTips">密   码 / password</p>
                    <Input prefix="ios-unlock-outline" @keyup.enter.native="login" v-model="password" placeholder="请输入您的密码" style="width: auto" type="password"/>
                </div>
                <div style="text-align: left;margin: 20px 0px 20px 45px;">
                    <!--<Radio v-model="single">记住我</Radio>-->
                </div>
                <Button type="primary" @click="login" style="width: 380px;height: 46px;border-radius: 22px;background-color: #00a2e9;font-size: 14px;">登录 / login</Button>
                <div style="text-align: left;margin-left: 45px;margin-top: 18px;">
                    <p style="color:#464c5b;font-size: 14px;display: inline-block;">还未注册，<router-link :to="{name:'register'}" class="register">去注册</router-link></p>
                    <p class="forgetPassword"><router-link :to="{name:'password'}" class="register">忘记密码？</router-link></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "login",
    data:function () {
      return{
        // single:false,
        phoneNumber:'',
        password:'',
      }
    },
		computed:{
			companyName:function(){
				return companyName
			},
		},
    methods:{
      login:function () {
        var _this = this
        _this.send({
          headers:"U/Login",
          data: {
            Login:_this.phoneNumber,
            PassWord:_this.password,
          },
          success: function (res) {
						_this.$cookies.set('userName',_this.phoneNumber)
						_this.$cookies.set('password',_this.password)
						window.sessionStorage.userToken = res.UserToken
						window.sessionStorage.phoneNumber = res.UserLogin
						window.sessionStorage.groupId = res.GroupId
						window.sessionStorage.userId = res.UserId
						window.sessionStorage.fullName = res.UserName
						window.sessionStorage.userIcon = res.UserImg
						window.sessionStorage.companyShortName = res.GroupShortName
						window.sessionStorage.groupName = res.PurviewName
						window.sessionStorage.companyName = res.GroupName
						SYSCONFIG.server.default.data.UserLogin = res.UserLogin
						SYSCONFIG.server.default.data.UserToken = res.UserToken
						SYSCONFIG.server.default.data.GroupId = res.GroupId
						_this.$router.push({name:'home'})
          }
        })
      }
    },
		mounted () {
			console.log(this.$cookies.get('userName'))
			if(!this.isEmpty(this.$cookies.get('userName'))){
					this.phoneNumber = this.$cookies.get('userName')
					this.password = this.$cookies.get('password')
					this.login()
			}
		},
  }
</script>
